import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToLoginIfUnauthorised(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authorisationStore = useAuthorisationStore();

  if (!authorisationStore.redirectToAfterLoginUrl) {
    authorisationStore.redirectToAfterLoginUrl = to.fullPath;
  }

  const authClient = await getAuthClient();
  const token = await authClient.getToken();
  if (!token) {
    return next({ name: "auth.login" });
  }
  return next();
}
